import { ChartDonutVariantIcon } from './ChartDonutVariantIcon';

/**
 * author: Austin Andrews
 * id FE9CBE2A-4D6F-4A1F-B817-26607BB9561B
 * name chart-donut-variant
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chart-donut-variant.svg
 * tags
 * - Math 
 */
export const ChartDoughnutVariantIcon = ChartDonutVariantIcon;
export default ChartDoughnutVariantIcon